import { useCallback, useEffect, useState } from 'react'

const useScrollToggle = (
  scrollDownThreshold: number,
  scrollUpThreshold: number
): boolean => {
  const [scroll, setScroll] = useState(false)
  const [prevScrollY, setPrevScrollY] = useState(0)

  const handleScroll = useCallback(() => {
    const currentScrollY = window.scrollY

    if (currentScrollY > scrollDownThreshold && currentScrollY > prevScrollY) {
      setScroll(true)
    } else if (
      currentScrollY <= scrollUpThreshold ||
      currentScrollY < prevScrollY
    ) {
      setScroll(false)
    }

    setPrevScrollY(currentScrollY)
  }, [prevScrollY, scrollDownThreshold, scrollUpThreshold])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  return scroll
}

export default useScrollToggle
